import { Button, Result } from 'antd';
import PageTitle from 'components/title/title';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleNavigateBack = () => {
		navigate(-1);
	};

	return (
		<>
			<PageTitle name={t('TITLE.NOT_FOUND')} />

			<Result
				status="404"
				title="404"
				style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
				subTitle={t('COMMON.NOT_FOUND_DESC')}
				extra={
					<Button type="primary" onClick={handleNavigateBack}>
						{t('COMMON.BACK')}
					</Button>
				}
			/>
		</>
	);
}

export default NotFoundPage;
